export default __webpack_public_path__ + "static/media/TriaLogo_Primary_Large_White.78420068.png";